<template>
    <v-dialog v-model="isOpen" persistent width="1000">
        <v-card class="elevation-4" style="border-radius: 12px; overflow: hidden;">
            <!-- Header con gradiente -->
            <v-card-title class="primary white--text pa-6"
                style="background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);">
                <v-row align="center" no-gutters>
                    <v-col>
                        <div class="d-flex align-center">
                            <v-icon large color="white" class="mr-3">mdi-file-excel</v-icon>
                            <div>
                                <h2 class="text-h5 font-weight-bold mb-1">
                                    Importación Masiva de Presupuesto Ágil
                                </h2>
                                <p class="mb-0 caption" style="opacity: 0.9;">
                                    Descargue la plantilla, complete los datos y cargue el archivo
                                </p>
                            </div>
                        </div>
                    </v-col>

                    <div class="d-flex" style="gap: 4px;">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn class="inline-block" v-on="on" @click="createExcelTemplate" fab dark small
                                    color="success">
                                    <i class="fas fa-download"></i>
                                </v-btn>
                            </template>
                            <span>Descargar Plantilla</span>
                        </v-tooltip>
                        <v-btn class="inline-block" fab dark small color="primary" @click="closeDialog">
                            <v-icon dark>mdi-close</v-icon>
                        </v-btn>
                    </div>
                </v-row>
            </v-card-title>

            <!-- Card de carga de Excel -->
            <v-container class="pa-3">
                <v-row justify="center">
                    <v-col cols="12">
                        <v-card outlined class="pa-3 rounded-xl"
                            style="border: 2px dashed #1976d2; background-color: #f5f9ff;">
                            <div class="text-center">
                                <h3>Importar Presupuesto Ágil</h3>
                                <p class="grey--text text--base">
                                    Descargue la plantilla, llene los datos y cargue el archivo aquí
                                </p>
                            </div>
                            <v-file-input v-model="excelFile" label="Seleccionar archivo Excel para cargar"
                                accept=".xlsx,.xls" @change="handleFileSelect()" small-chips show-size
                                prepend-icon="mdi-file-upload" />
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>

            <!-- Loading -->
            <v-dialog v-model="loadingImport" hide-overlay persistent width="300">
                <v-card color="primary" dark>
                    <v-card-text>
                        Procesando archivo...
                        <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-dialog>

             <!-- Saving Progress -->
             <v-dialog v-model="savingData" hide-overlay persistent width="300">
                <v-card color="primary" dark>
                    <v-card-text>
                        Guardando registros... {{ totalSave }} / {{ headersData.length }}
                        <v-progress-linear :value="(totalSave / headersData.length) * 100" color="white" class="mb-0"></v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-dialog>


            <!-- Vista previa de datos -->
            <v-container v-if="headersData.length > 0">
                <v-row justify="center">
                    <v-col cols="12">
                        <v-card outlined style="border-radius: 8px;">
                            <v-card-title class="pb-2">
                                <v-icon color="primary" class="mr-2">mdi-table-eye</v-icon>
                                <span class="text-h6 font-weight-medium">Vista Previa de Datos</span>
                                <v-spacer></v-spacer>

                                <v-chip color="info" outlined small>
                                    {{ headersData.length }} registros
                                </v-chip>

                                <v-chip color="error" outlined small class="ml-2" v-if="totalErrores > 0">
                                    {{ totalErrores }} filas con errores
                                </v-chip>

                            </v-card-title>

                            <v-divider></v-divider>

                            <v-card-text class="pa-0">
                                <v-data-table :headers="headersTablePreview" :items="headersData" :items-per-page="5"
                                    class="elevation-0" loading-text="Cargando datos...">
                                     <template v-slot:item.errorMessages="{ item }">
                                        <span v-if="item.errorMessages" class="error--text">{{ item.errorMessages }}</span>
                                        <span v-else class="success--text">OK</span>
                                    </template>
                                </v-data-table>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>

                <!-- Sección de acciones -->
                <v-row v-if="totalErrores == 0" class="">
                    <v-col cols="12">
                        <div class="d-flex justify-end">
                            <v-btn large outlined color="grey darken-1" class="mr-3 text-none" @click="closeDialog">
                                <v-icon left>mdi-close</v-icon>
                                Cancelar
                            </v-btn>
                            <v-btn large color="success" class="text-none px-8" @click="saveExcel()"
                                :loading="savingData" :disabled="savingData">
                                <v-icon left>mdi-content-save</v-icon>
                                Guardar Registros
                            </v-btn>
                        </div>
                    </v-col>
                </v-row>

            </v-container>

        </v-card>
    </v-dialog>
</template>

<script>
import _sBudgetAgileService from "@/services/Accounting/BudgetAgileService";

const FIELD_VALIDATIONS = {
    "CONDICIÓN": { required: false, type: 'string', nullable: true },
    "Cod CC": { required: false, type: 'int', nullable: false },
    "CENTRO COSTOS": { required: false, type: 'string', nullable: true },
    "COD CUENTA": { required: false, type: 'int', nullable: false },
    "DENOMINACION": { required: false, type: 'string', nullable: true },
    "GRUPO CUENTAS": { required: false, type: 'string', nullable: true },
    "CUENTA_CECO": { required: false, type: 'long', nullable: false },
    "Gerente enviado": { required: false, type: 'string', nullable: true },
    "Responsable enviado": { required: false, type: 'string', nullable: true },
    "GERENTE RESPONSABLE": { required: false, type: 'string', nullable: true },
    "RESPONSABLE": { required: false, type: 'string', nullable: true },
    "GERENCIA USUARIA": { required: false, type: 'string', nullable: true },
    "AREA": { required: false, type: 'string', nullable: true },
    "COD_2D": { required: false, type: 'int', nullable: false },
    "TIPO GASTO": { required: false, type: 'string', nullable: true },
    "COD LINEA NEGOCIO": { required: false, type: 'int', nullable: false },
    "LINEA NEGOCIO": { required: false, type: 'string', nullable: true },
    "COD TIPO COSTO": { required: false, type: 'string', nullable: true },
    "COD TIPO COSTO 2": { required: false, type: 'decimal', nullable: true },
    "Código de material / servicio (*)": { required: false, type: 'string', nullable: true },
    "Descripción del Material / Servicio (*)": { required: false, type: 'string', nullable: true },
    "GLOSA": { required: false, type: 'string', nullable: true },
    "AÑO": { required: false, type: 'int', nullable: false },
    "MES (*)": { required: false, type: 'string', nullable: true },
    "CANTIDAD (*)": { required: false, type: 'decimal', nullable: true },
    "UM (*)": { required: false, type: 'string', nullable: true },
    "PU (*)": { required: false, type: 'decimal', nullable: true },
    "Moneda Origen (*)": { required: false, type: 'string', nullable: true },
    "Total Moneda Origen (**)": { required: false, type: 'decimal', nullable: true },
    "Tipo de cambio (**)": { required: false, type: 'decimal', nullable: true },
    "TOTAL USD (**)": { required: false, type: 'decimal', nullable: false },
    "TOTAL PEN (**)": { required: false, type: 'decimal', nullable: false },
};

export default {
    props: {
        isOpen: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            excelFile: null,
            loadingImport: false,
            headersData: [],
            totalSave: 0,
            savingData: false,
            headersTablePreview: [],
        };
    },
    methods: {
        closeDialog() {
            this.headersData = []
            this.excelFile = null;
            this.$emit('update:isOpen', false);
            this.$emit("close");
        },
        async handleFileSelect() {
            this.loadingImport = true;

            if (!this.excelFile) {
                this.resetImport();
                return;
            }

            try {
                const ExcelJS = require("exceljs");
                const reader = new FileReader();

                reader.onload = async (e) => {
                    try {
                        const workbook = new ExcelJS.Workbook();
                        await workbook.xlsx.load(e.target.result);

                        const wsHeaders = workbook.getWorksheet(1); // Cargar la primera hoja
                        if (!wsHeaders) {
                            this.$fun.alert("El archivo no tiene hojas", "error");
                            this.loadingImport = false;
                            return;
                        }

                        const rowsTable = this.leerHojaExcel(wsHeaders);
                        this.generateDynamicHeaders(wsHeaders);

                        this.headersData = await this.validateRows(rowsTable);
                        this.loadingImport = false;

                        this.$fun.alert(
                            `Cargado: ${rowsTable.length} registros`,
                            "success"
                        );
                    } catch (parseError) {
                        console.error("Error parsing Excel:", parseError);
                        this.loadingImport = false;
                        this.$fun.alert("Error al leer el archivo Excel. Asegúrese de que no esté dañado o tenga formatos complejos (comentarios, macros).", "error");
                    }
                };

                reader.readAsArrayBuffer(this.excelFile);

            } catch (error) {
                console.error(error);
                this.loadingImport = false;
                this.$fun.alert("Error al procesar el archivo", "error");
            }
        },
        resetImport() {
            this.loadingImport = false;
            this.headersData = [];
            this.excelFile = null;
        },
        leerHojaExcel(ws) {
            const data = [];

            // Leer encabezados reales (fila 1)
            const headers = ws.getRow(1).values
                .slice(1)
                .map(h => h?.toString().trim());

            ws.eachRow({ includeEmpty: true }, (row, rowNumber) => {
                if (rowNumber === 1) return; // ❌ no leer cabecera

                const rowData = {};
                let hasData = false;

                // Leer todas las columnas, incluso vacías
                row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
                    let value = cell.value;

                    // Soporte para celdas con fórmula
                    if (value && typeof value === "object" && value.result !== undefined) {
                        value = value.result;
                    }

                    if (value !== null && value !== undefined && value !== "") {
                        hasData = true;
                    }

                    const header = headers[colNumber - 1];
                    if (header) {
                        rowData[header] = value;
                    }
                });

                // ❌ ignorar filas totalmente vacías
                if (!hasData) return;

                rowData.Fila = rowNumber; // número real de fila Excel
                data.push(rowData);
            });

            return data;
        },
        async validateRows(rows) {
            return await Promise.all(
                rows.map(row => this.validateRow(row))
            );
        },
        async validateRow(row) {
            const errors = [];
            
            Object.entries(FIELD_VALIDATIONS).forEach(([field, rules]) => {
                let value = row[field];

                // 1️⃣ Validación de requerido
                if (rules.required) {
                    if (value === null || value === undefined || (typeof value === 'string' && value.trim() === '')) {
                        errors.push(`El campo ${field} es obligatorio`);
                        return;
                    }
                }

                // 2️⃣ Validación de tipo y conversión
                if (value !== null && value !== undefined && value !== '') {
                    if (rules.type === 'string') {
                        row[field] = String(value).trim();
                    } 
                    else if (rules.type === 'int') {
                        const intValue = parseInt(value);
                        if (isNaN(intValue)) {
                            errors.push(`El campo ${field} debe ser un número entero`);
                        } else {
                            row[field] = intValue;
                        }
                    } 
                    else if (rules.type === 'long') {
                        // Para bigint, validamos que sea un número entero válido
                        const longValue = parseInt(value);
                        if (isNaN(longValue)) {
                            errors.push(`El campo ${field} debe ser un número entero (bigint)`);
                        } else {
                            row[field] = longValue;
                        }
                    }
                    else if (rules.type === 'decimal') {
                        const decimalValue = parseFloat(value);
                        if (isNaN(decimalValue)) {
                            errors.push(`El campo ${field} debe ser un número decimal`);
                        } else {
                            row[field] = decimalValue;
                        }
                    }
                } else {
                    // 3️⃣ Validación de campos NOT NULL (nullable: false)
                    if (!rules.nullable && (value === null || value === undefined || value === '')) {
                        // Para campos numéricos NOT NULL, asignar 0 por defecto
                        if (rules.type === 'int' || rules.type === 'long') {
                            row[field] = 0;
                        } else if (rules.type === 'decimal') {
                            row[field] = 0.0;
                        } else if (rules.type === 'string') {
                            row[field] = '';
                        }
                    } else {
                        // Para campos nullable, asignar null
                        row[field] = null;
                    }
                }
            });

            const errorMessages = errors.join("; ");

            return {
                ...row,
                isValid: errors.length === 0,
                errors,
                errorMessages
            };
        },
        generateDynamicHeaders(worksheet) {
            const headers = [];

            // Tomamos todas las columnas que vienen del Excel (primera fila)
            worksheet.getRow(1).eachCell((cell) => {
                if (cell.value) {
                    const columnName = cell.value.toString().trim();
                     headers.push({
                        text: columnName,
                        value: columnName,
                        width: columnName === "Fila" ? 50 : 150,
                    });
                }
            });

            // Columnas adicionales siempre al final
            headers.push(
                {
                    text: "Errores",
                    value: "errorMessages",
                    width: 200,
                    sortable: false,
                }
            );

            this.headersTablePreview = headers;
        },
        saveExcel() {
            this.$fun.alert("¿Seguro de guardar?", "question").then(async (r) => {
                if (r) {
                    this.savingData = true;
                    this.totalSave = 0;
                    let errorCount = 0;

                    for (const row of this.headersData) {
                        // Mapear campos del Excel a campos del modelo
                        const budgetItem = {
                            BgtID: 0,
                            BgtCondition: row["CONDICIÓN"],
                            BgtCodeCC: row["Cod CC"],
                            BgtCostCenter: row["CENTRO COSTOS"],
                            BgtAccountCode: row["COD CUENTA"],
                            BgtDenomination: row["DENOMINACION"],
                            BgtAccountGroup: row["GRUPO CUENTAS"],
                            BgtAccountCeco: row["CUENTA_CECO"],
                            BgtManagerSent: row["Gerente enviado"],
                            BgtResponsibleSent: row["Responsable enviado"],
                            BgtManagerResponsible: row["GERENTE RESPONSABLE"],
                            BgtResponsible: row["RESPONSABLE"],
                            BgtUserManagement: row["GERENCIA USUARIA"],
                            BgtArea: row["AREA"],
                            BgtCode2D: row["COD_2D"],
                            BgtExpenseType: row["TIPO GASTO"],
                            BgtBusinessLineCode: row["COD LINEA NEGOCIO"],
                            BgtBusinessLine: row["LINEA NEGOCIO"],
                            BgtCostTypeCode: row["COD TIPO COSTO"],
                            BgtCostTypeCode2: row["COD TIPO COSTO 2"],
                            BgtMaterialServiceCode: row["Código de material / servicio (*)"],
                            BgtMaterialServiceDescription: row["Descripción del Material / Servicio (*)"],
                            BgtGloss: row["GLOSA"],
                            BgtYear: row["AÑO"],
                            BgtMonth: row["MES (*)"],
                            BgtQuantity: row["CANTIDAD (*)"],
                            BgtUnitMeasure: row["UM (*)"],
                            BgtUnitPrice: row["PU (*)"],
                            BgtOriginCurrency: row["Moneda Origen (*)"],
                            BgtTotalOriginCurrency: row["Total Moneda Origen (**)"],
                            BgtExchangeRate: row["Tipo de cambio (**)"],
                            BgtTotalUSD: row["TOTAL USD (**)"],
                            BgtTotalPEN: row["TOTAL PEN (**)"],
                            UsrCreateID: this.$fun.getUserID()
                        };

                        try {
                            await _sBudgetAgileService.save(budgetItem, this.$fun.getUserID());
                            this.totalSave++;
                        } catch (err) {
                            console.error(`Error al guardar fila ${row.Fila}`, err);
                            errorCount++;
                        }
                    }

                    this.savingData = false;
                    
                    if (errorCount === 0) {
                        this.$fun.alert(`¡Excelente! ${this.totalSave} registros guardados correctamente`, "success");
                        this.closeDialog();
                        this.$emit("saved"); 
                    } else {
                        this.$fun.alert(`Se guardaron ${this.totalSave} registros, pero hubo ${errorCount} errores.`, "warning");
                    }
                }
            });
        },
        createExcelTemplate() {
            try {
                const ExcelJS = require("exceljs");
                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet("Plantilla Presupuesto");

                // Headers
                const headers = Object.keys(FIELD_VALIDATIONS);

                worksheet.addRow(headers);

                // Estilo encabezado (azul)
                worksheet.getRow(1).eachCell(cell => {
                    cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
                    cell.fill = {
                        type: "pattern",
                        pattern: "solid",
                        fgColor: { argb: "FF1976D2" }
                    };
                    cell.alignment = { vertical: "middle", horizontal: "center" };
                });

                // Ajustar ancho
                worksheet.columns.forEach(col => col.width = 20);

                // Descargar archivo
                workbook.xlsx.writeBuffer().then(buffer => {
                    const blob = new Blob([buffer], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    });

                    const link = document.createElement("a");
                    link.href = URL.createObjectURL(blob);
                    link.download = "Plantilla_PresupuestoAgil.xlsx";
                    link.click();
                });

            } catch (error) {
                console.error(error);
                this.$fun.alert("Error al generar la plantilla", "error");
            }
        }
    },
    computed: {
        totalErrores() {
            if (!this.headersData) return 0;
            return this.headersData.filter(row => row.errors && row.errors.length > 0).length;
        }
    }
}
</script>
